import { FC } from 'react'

import { paymentPlanFilterOptions } from '@new/__global/components/Filters/Filters.constants'

import { FiltersSharedProps } from './Filters.types'
import { RadioBasedField } from './FiltersVariations/Radio'

interface CleanCreatedFilterProps extends FiltersSharedProps {
  title: string
  onChange: (value?: string) => void
  initialValue?: string
}

export const CleanCreatedFilter: FC<CleanCreatedFilterProps> = props => {
  return (
    <RadioBasedField
      radioGroupId="cleanCreatedFilterFilterGroup"
      options={paymentPlanFilterOptions}
      {...props}
    />
  )
}
